<template>
    <!-- eslint-disable vue/no-unused-vars -->

    <div class="vc-panel" v-if="currentWord != null" v-loading="showLoading">
        <div class="vh-full vh-flex" v-if="learnFinished == false">
            <!--spell head-->
            <div class="vheader vh-flex">
                <div class="vh-full v-top">
                    <div class="vc-flex">
                        <IconView @click="goBack" svgname="ic_left1" backColor="var(--ek-card-color1)" :iconSize="16"
                            :ctnSize="35" :radius="35"></IconView>
                        <div class="lbleft mgl10">{{ bookName }}</div>
                        <SvgIcon class="xg1" svgname="ic_xiegan" :size="14" fill="var(--ek-text-color3)"></SvgIcon>
                        <div class="lbleft">{{ unitName }}</div>
                        <SvgIcon class="xg1" svgname="ic_xiegan" :size="14" fill="var(--ek-text-color3)"></SvgIcon>
                        <div class="lbleft">{{ (currentWordIndex + 1) }}/{{ totalCount }}</div>
                        <div class="lbcurword">{{ currentWord.ItemName }}</div>
                    </div>
                    <div class="v-flex" style="gap: 20px;">
                        <!--计时器-->
                        <div @click="timer.enable = !timer.enable" class="vc-flex focus-s">
                            <SvgIcon svgname="ic_oclock" :size="18"
                                :fill="timer.enable ? 'var(--ek-text-color2)' : '#ff0d0d'"></SvgIcon>
                            <span class="ctime"
                                :style="{ 'color': timer.enable ? 'var(--ek-text-color2)' : '#ff0d0d' }">{{
                                    timer.showTime }}</span>
                        </div>
                        <!--主题切换-->
                        <ThemeSwitchView></ThemeSwitchView>

                        <el-tooltip class="box-item" effect="dark" content="设置" placement="bottom">
                            <IconView @click="openConfigDialog" svgname="ic_basic_setting" :iconSize="20" :ctnSize="30"
                                :radius="5"></IconView>
                        </el-tooltip>
                    </div>
                </div>
                <div class="wordProgress">
                    <div class="wpv" :style="{ 'flex-grow': learnProgress }"></div>
                </div>
            </div>
            <div v-if="audioNotAllowedError" class="vp1">
                <div @click="playText(currentWord.sentence)" class="vpplay focus-s vc-flex">
                    <SvgIcon svgname="ic_sound_none" :size="20" fill="white"></SvgIcon>
                    <span class="mgl5">音频播放被拦截，点击此处开启</span>
                </div>
            </div>
            <div class="spell-container">
                <div class="spell-item" v-if="spellItem != null">
                    <div class="lbtrans" @mouseleave="translateEnter = false"
                        v-if="config.showTranslate || translateEnter" :style="{ 'font-size': config.translateSize }">
                        {{ spellItem.translate }}</div>
                    <div class="lbtrans" v-else @mouseenter="translateEnter = true"
                        style="color: var(--ek-text-color3);" :style="{ 'font-size': config.translateSize }">
                        -------------</div>
                    <!--音标区域-->
                    <div class="dsymbol" v-if="config.symbolVisible == 'show' || showResultConfirm">
                        <div :style="{ 'font-size': config.symbolSize }">{{ symbolWrapper(spellItem.symbol) }}</div>
                    </div>
                    <div class="lbspell" :style="{ 'font-size': config.textSize }">
                        <div class="spitem"
                            :class="{ 'shake': word.animate == true, 'curspellword': windex == spellWordIndex }"
                            @animationend="word.animate = false" v-for="(word, windex) in spellItem.items" :key="word"
                            @mouseenter="setWordMShow(word, 1)" @mouseleave="setWordMShow(word, 0)"
                            @click="clickSpellWord(word)">
                            <div class="char-item" v-for="(char, cindex) in word.chars" :key="char">
                                <span class="uninput"
                                    :class="{ 'unshow': (char.show == 1 || char.type == 1 || char.mshow == 1) }"
                                    v-if="char.input == 0">{{ char.char
                                    }}</span>
                                <span class="char-right" v-else-if="char.input == 1">{{ char.char }}</span>
                                <span class="char-err" v-else-if="char.input == 2">{{ char.errChar }}</span>
                            </div>
                        </div>

                    </div>
                    <div class="lbspellpage">{{ (spellItemIndex + 1) }}/{{ listSpellItems.length }}</div>
                    <!--确认提示-->
                    <div class="cfg1" v-if="showResultConfirm">
                        <div @click="continueToNext" class="cfg2 focus-s">
                            <!-- <SvgIcon svgname="ic_space" :size="18" fill="var(--ek-text-color2)"></SvgIcon> -->

                            <span>继续</span>
                            <SvgIcon class="mgl10" svgname="ic_space" :size="18" fill="var(--ek-text-color2)"></SvgIcon>
                        </div>
                    </div>
                </div>
            </div>

            <!--底部快捷键-->
            <div class="vbottom">
                <div>
                    <span class="vkey">Tab</span>
                    <span class="vkeytip">词汇显示</span>
                </div>
                <div>
                    <span class="vkey">~</span>
                    <span class="vkeytip">添加生词</span>
                </div>
                <div>
                    <span class="vkey">Space</span>
                    <span class="vkeytip">全句显示</span>
                </div>
                <div>
                    <span class="vkey">Ctrl + P</span>
                    <span class="vkeytip">播放句子</span>
                </div>

            </div>
        </div>
        <SpellLearnFinish v-else @eventHandle="finishEvent"></SpellLearnFinish>
        <!--拼写设置-->
        <SpellSettingDialog :showDialog="configDialog.show" @closeDialog="configDialog.callBack"></SpellSettingDialog>
    </div>
</template>

<script>
/* global LightApp */
import SvgIcon from '@/components/SvgIcon.vue';
import IconMenu from '@/components/IconMenu.vue';
import localCache from '@/commom/local/LocalCache';
import IconView from '@/components/IconView.vue';
import httpClient from '@/commom/http/httpClient';
import ThemeSwitchView from '@/components/ThemeSwitchView.vue';
import textSoundPlayer from '@/commom/media/TextSoundPlayer.js';
import SpellSettingDialog from './dialog/SpellSettingDialog.vue';
import spellConfig from '@/commom/config/SpellConfig'
import stringHelper from '@/commom/string/StringHelper';
import confetti from 'canvas-confetti';
import SpellLearnFinish from './views/SpellLearnFinish.vue';



var _app = null;
export default {
    name: 'SpellWordTools',
    components: {
        IconMenu,
        SvgIcon,
        IconView,
        ThemeSwitchView,
        SpellSettingDialog,
        SpellLearnFinish
    },
    props: {

    },
    data() {
        return {
            bookName: "",
            unitName: "",
            config: {
                autoPlay: 0,
                finishWaitConfirm: false,
                playSpeed: 1,
                showTranslate: true,
                loopMode: "order",
                loopName: "",
                soundName: "US",
                keyboardSound: "",//键盘音效
                errorSound: "",//错误音效
                correctSound: "",//正确音效
                symbolVisible: "show",//音标显示
                translateSize: "30px",//译文字体大小
                symbolSize: "24px",//音标字体大小
                textSize: "30px",//拼写字体大小
            },
            audio: null,
            keyboardAudio: null,
            listWord: [],
            mapSentence: {},
            totalCount: 0,
            currentWordIndex: -1, // 当前单词索引
            currentWord: null, // 当前单词
            listSpellItems: [], //拼写项目
            spellItemIndex: -1,//当前句子索引
            spellItem: null,//当前句子
            spellWordIndex: 0,//当前输入句子中的单词索引
            inputError: false,//存在输入错误标识
            showAnswer: 0,
            learnProgress: 0.0, //本次学习进度
            translateEnter: false,
            loopCount: 0,
            learnFinished: false,
            learnModel: null,
            dataLoading: false, //是否加载加载数据中
            showLoading: false,
            showResultConfirm: false,//显示结果确认按钮

            submitData: {
                timerId: -1,
                submitStatus: 0,//0=未提交，1=提交中
                ///学习数据
                listLearnItem: []
            },
            ///计时器
            timer: {
                timerId: -1,
                enable: true,
                time: 0,
                uploadTime: 0,
                showTime: "00:00"
            },
            ///配置对话框
            configDialog: {
                show: false,
                callBack: null
            },
            audioNotAllowedError: false,
            boundKeydown: null
        }
    },
    // 挂载完成
    mounted: function () {
        _app = this
        this.audio = new Audio()
        var that = this
        this.boundKeydown = function (e) {
            that.keyEvent(e)
        }
        window.addEventListener("keydown", this.boundKeydown)
        this.init();

    },
    beforeUnmount: function () {
        // 移除事件监听器
        window.removeEventListener("keydown", this.boundKeydown)
    },
    unmounted: function () {

        clearInterval(this.submitData.timerId)
        clearInterval(this.timer.timerId)
    },
    methods: {
        // 初始化加载
        init: function () {
            var that = this
            this.loadConfig()
            this.initData();
            this.submitData.timerId = setInterval(this.uploadLearnData, 1000 * 30)
            ///启动计时器
            this.timer.timerId = setInterval(this.updateTimer, 1000)


        },
        ///更新计时
        updateTimer: function () {
            if (!_app.timer.enable) {
                return
            }
            if (_app.learnFinished) {
                ///如果已经学习完成，则不在进行记录了
                return
            }
            // 递增秒数
            _app.timer.time++;
            _app.timer.uploadTime++

            // 格式化时间为MM:SS格式
            const minutes = Math.floor(_app.timer.time / 60);
            const seconds = _app.timer.time % 60;

            // 补零确保两位数显示
            const formattedMinutes = minutes.toString().padStart(2, '0');
            const formattedSeconds = seconds.toString().padStart(2, '0');

            // 更新显示时间
            _app.timer.showTime = `${formattedMinutes}:${formattedSeconds}`;
        },
        ///上传学习数据
        uploadLearnData: function (callBack) {
            console.log("提交数据")
            if (_app.submitData.listLearnItem.length == 0 && _app.timer.uploadTime < 10) {
                console.log("没有数据可提交")
                if (callBack != null) {
                    callBack()
                }
                return
            }
            if (_app.submitData.submitStatus == 1) {
                console.log("检测到正在提交。。")
                if (callBack != null) {
                    callBack()
                }
                return
            }
            _app.submitData.submitStatus = 1
            var req = {
                items: JSON.stringify(_app.submitData.listLearnItem),
                unitId: _app.learnModel.unitInfo.unitId,
                time: _app.timer.uploadTime
            }
            _app.timer.uploadTime = 0
            _app.submitData.listLearnItem = []
            httpClient.invoke("LearnAPI.UploadLearnData", req, function (res) {
                console.log("提交学习数据返回", res)
                _app.submitData.submitStatus = 0
                if (callBack != null) {
                    callBack(res)
                } 
                if (res.error) {
                    //发生错误，将数据放回到队列里面去
                    _app.submitData.listLearnItem.push(...req.items)
                    _app.$message({ message: res.error })
                    return
                }

            })

        },
        ///初始化数据
        initData: function () {
            this.learnFinished = false
            this.learnModel = localCache.getObject("learnModel")
            if (this.learnModel == null) {
                this.$message.error("参数错误")
                this.$router.go(-1)
                return
            }
            this.bookName = this.learnModel.bookInfo.bookName
            this.unitName = this.learnModel.unitInfo.unitName
            this.totalCount = this.learnModel.learnInfo.listId.length
            this.listWord = []
            this.mapSentence = {}

            for (var i = 0; i < this.learnModel.learnInfo.listId.length; i++) {
                var model = {
                    id: this.learnModel.learnInfo.listId[i]
                }
                this.listWord.push(model)
                this.mapSentence[model.id] = model
            }
            this.currentWordIndex = this.learnModel.learnInfo.index
            ///显示加载
            this.showLoading = true
            var that = this
            this.fillData(function () {
                that.showLoading = false
                //console.log("填充数据完成",that.listWord)
                that.loadCurrentWord()
            })
            //this.moveToNext()
        },
        ///填充数据
        fillData: function (callBack) {
            var listReqId = []
            var leftMinIndex = this.currentWordIndex - 10
            var rightMaxIndex = this.currentWordIndex + 10
            var index = this.currentWordIndex
            while (index > leftMinIndex && index >= 0) {
                if (this.listWord[index].sentenceId == null) {
                    listReqId.push(this.listWord[index].id)
                }
                index--
            }
            index = this.currentWordIndex + 1
            while (index < rightMaxIndex && index < this.totalCount) {
                if (this.listWord[index].sentenceId == null) {
                    listReqId.push(this.listWord[index].id)
                }
                index++
            }
            if (listReqId.length == 0) {
                ///如果没有数据
                callBack()
                return;
            }
            //如果不足5个不加载
            if (listReqId.length < 5 && rightMaxIndex < this.totalCount) {
                callBack()
                return;
            }
            var req = {
                bookId: this.learnModel.bookInfo.bookId,
                unitId: this.learnModel.unitInfo.unitId,
                items: listReqId.join(",")
            }
            var that = this
            httpClient.invoke("LearnAPI.FillSentenceLearnData", req, function (rows) {
                console.log("填充数据返回", rows)
                if (rows.error) {
                    that.$message.error(rows.error)
                    callBack()
                    return
                }
                for (var i = 0; i < rows.length; i++) {
                    var row = rows[i]
                    var model = that.mapSentence[row.sentenceId]
                    Object.assign(model, row)
                }
                callBack()
            })
        },
        ///加载配置文件
        loadConfig: function (callBack) {
            var that = this
            var _config = spellConfig.getConfig()
            this.config.autoPlay = parseInt(_config.basic.autoPlay)
            this.config.finishWaitConfirm = _config.basic.finishWaitConfirm == "1" ? true : false
            this.config.keyboardSound = _config.soundEffect.keyboard
            this.config.errorSound = _config.soundEffect.error
            this.config.correctSound = _config.soundEffect.correct
            this.config.symbolVisible = _config.basic.symbolVisible
            this.config.loopMode = _config.basic.loopMode
            this.config.translateSize = _config.font.translateSize + "px"
            this.config.symbolSize = _config.font.symbolSize + "px"
            this.config.textSize = _config.font.textSize + "px"

            //初始化键盘按键音
            if (this.config.keyboardSound != "") {
                this.keyboardAudio = new Audio(`./sound/${this.config.keyboardSound}`)
                this.keyboardAudio.load()
            } else {
                this.keyboardAudio = null
            }


        },
        ///键盘事件
        keyEvent: function (event) {
            //console.log("键盘事件",event)
            // 添加 Ctrl+J 播放发音快捷键
            if (event.ctrlKey && (event.key === 'j' || event.key === 'J')) {
                // event.preventDefault() // 阻止默认行为
                // this.playWordSound()
            }
            if (event.ctrlKey && (event.key === 'p' || event.key === 'P')) {
                event.preventDefault() // 阻止默认行为
                this.playText(this.spellItem.sentence)
                return
                // this.playWordSound()
            }
            if (event.altKey && (event.key === 'w' || event.key === 'W')) {
                // event.preventDefault() // 阻止默认行为
                // this.configChange({name:"hideWrite"})
            }
            else if (event.keyCode >= 65 && event.keyCode <= 90) {

                this.inputWordKey(event.key)
                this.playKeyboardSound()
                return
            }
            else if (event.keyCode == 8) { // Backspace

                event.preventDefault() // 阻止默认行为
                this.playKeyboardSound()
                this.handleBackspace();
            }
            else if (event.keyCode == 32) {
                ///空格键
                if (this.learnFinished) {
                    this.goBack()
                    return
                }
                this.playKeyboardSound()
                if (this.showResultConfirm) {
                    this.continueToNext()
                    return
                }
                this.changeAllSpellWordShow()
                return
            }
            else if (event.ctrlKey && event.key === 'ArrowUp') {
                // 上一句
                this.movePrevSpellItem();
            }
            else if (event.ctrlKey && event.key === 'ArrowDown') {
                // 下一句
                this.moveNextSpellItem();
            }
            // 添加快捷键判断
            else if (event.shiftKey && event.key === 'ArrowLeft') {
                // 上一个
                //this.moveToLast()
            }
            else if (event.shiftKey && event.key === 'ArrowRight') {
                // 下一个
                //this.moveToNext()
            } else if (event.key == "Tab") {
                event.preventDefault() // 阻止默认行为
                this.changeSpellWordShow()
                //this.changeAllSpellWordShow()
            }
            else if (event.key == "`" || event.key == "~") {
                ///添加生词
                this.addNewWord()
                return
            }
            else if (event.key == "Enter") {
                if (this.learnFinished) {
                    this.goBack()
                    return
                }
                this.playKeyboardSound()
                if (this.showResultConfirm) {
                    this.continueToNext()
                    return
                }
            }

        },
        ///输入单词键
        inputWordKey: function (key) {
            if (this.inputError) return;

            key = key.toLocaleLowerCase();
            const charObj = this.getCurrentInputChar();
            if (!charObj) return;

            // 判断输入是否正确
            if (charObj.char.toLocaleLowerCase() === key) {
                charObj.input = 1; // 输入正确
            } else {
                charObj.errChar = key;
                charObj.input = 2; // 输入错误
                this.inputError = true;

                // 错误处理分支
                const spellWord = this.getCurrentSpellWord();
                spellWord.animate = true;
                this.spellItem.error = true;

                this.playErrorSound();
                return;
            }

            // 判断是否全部输入完毕
            // 优化：findIndex查找未输入或错误字符
            const items = this.spellItem.items;
            const unfinishedIndex = items.findIndex(wordObj =>
                wordObj.chars.some(c => (c.input === 0 || c.input == 2) && c.type === 0)
            );

            if (unfinishedIndex !== -1) {
                // 未完成，记录当前未完成的index（如果有用）
                this.spellWordIndex = unfinishedIndex;
                return;
            }

            // 全部输入正确
            this.playCorrectSound();

            if (this.config.finishWaitConfirm) {
                this.showResultConfirm = true;
                this.playText(this.spellItem.sentence);
            } else {
                setTimeout(() => {
                    this.handleLoopLogic();
                }, 300);
            }
        },
        ///继续下一个
        continueToNext: function () {
            this.showResultConfirm = false
            this.handleLoopLogic();
        },
        handleBackspace: function () {
            // 回删当前拼写项目最后一个已输入的字母
            if (!this.spellItem || !this.spellItem.items) return;
            for (let i = this.spellItem.items.length - 1; i >= 0; i--) {
                let wordObj = this.spellItem.items[i];
                for (let j = wordObj.chars.length - 1; j >= 0; j--) {
                    let charObj = wordObj.chars[j];
                    if (charObj.type == 0 && charObj.input !== 0) {
                        charObj.input = 0;
                        charObj.errChar = '';
                        this.inputError = false;
                        this.spellWordIndex = i
                        //this.$forceUpdate();
                        return;
                    }
                }
            }
        },
        // 获取当前需要输入的charObj
        getCurrentInputChar() {
            if (!this.spellItem || !this.spellItem.items) return null;
            for (let wordObj of this.spellItem.items) {
                for (let charObj of wordObj.chars) {
                    if (charObj.type == 0 && charObj.input === 0) {
                        return charObj;
                    }
                }
            }
            return null;
        },
        ///获取当前拼写单词
        getCurrentSpellWord() {
            if (!this.spellItem || !this.spellItem.items) return null;
            for (let wordObj of this.spellItem.items) {
                for (let charObj of wordObj.chars) {
                    if (charObj.type == 0 && (charObj.input === 0 || charObj.input === 2)) {
                        return wordObj;
                    }
                }
            }
            return null;
        },
        ///本次学习结束
        learnFinish: function () {
            this.learnFinished = true
            this.fireSuccessEffect()
            this.playAssetsSound(`./sound/learn_complete.mp3`)
            if (this.submitData.listLearnItem.length > 0) {
                this.uploadLearnData()
            }
        },
        ///完成事件
        finishEvent: function (ev) {
            switch (ev.name) {
                case "leave":
                    this.goBack()
                    break;
                case "restart":
                    this.restartLearn()
                    break;
                case "nextChapter"://切换到下一章
                    this.nextChapter()
                    break

            }
        },
        ///重新开始学习
        restartLearn: function () {
            this.currentWordIndex = 0
            this.learnFinished = false
            this.loadCurrentWord()
        },
        ///切换到下一个章节
        nextChapter: function () {
            var that = this
            var req = {
                bookId: this.learnModel.bookInfo.bookId,
                unitId: this.learnModel.unitInfo.unitId
            }
            httpClient.invoke("BookUnitAPI.GetNextUnit", req, function (res) {
                if (res.error) {
                    that.$message.error(res.error)
                    return
                }
                if (res.nextUnit == null) {
                    that.$message({ message: "已经没有下一章了" })
                    return
                }
                that.reloadUnitData(res.nextUnit.id, res.nextUnit.name)
                //console.log("下一个单元",res)
            })
        },
        ///重新加载指定单元数据
        reloadUnitData: function (unitId, unitName) {
            var that = this
            const learnType = "order"
            var req = {
                bookId: this.learnModel.bookInfo.bookId,
                unitId: unitId,
                learnType: learnType
            }
            //this.showLoading = true
            httpClient.invoke("LearnAPI.GetLearnIndex", req, function (res) {
                //console.log("返回结果", res)
                //that.showLoading = false
                if (res.error) {
                    that.$message.error(res.error.message)
                    return
                }
                if (res.listId.length == 0) {
                    that.$message({ message: "没有可学习的数据" });
                    return
                }
                var learnModel = {
                    learnInfo: res,
                    learnType: learnType,
                    bookInfo: {
                        bookId: that.learnModel.bookInfo.bookId,
                        bookName: that.learnModel.bookInfo.bookName,
                    },
                    unitInfo: {
                        unitId: unitId,
                        unitName: unitName
                    }
                }
                localCache.setObject("learnModel", learnModel)
                
                that.initData()

            })
        },
        ///加载下一个单词
        moveToNext: function () {
            if (this.currentWordIndex + 1 >= this.totalCount) {
                this.learnFinish()
                return
            }
            this.currentWordIndex++
            this.loadCurrentWord()
            this.checkPreloadData()

            this.fillData(function () { })
        },
        ///检查加载更多数据
        checkPreloadData: function () {
            var rcount = this.listWord.length - this.currentWordIndex;
            //console.log("rcount",rcount)
            if (rcount <= 5 && this.listWord.length < this.totalCount && !this.dataLoading) {
                this.loadMoreData()
                return
            }
            //console.log("无需加载")
        },
        ///加载更多数据
        loadMoreData: function () {
            this.dataLoading = true
            this.learnModel.req.page += 1
            var req = JSON.parse(JSON.stringify(this.learnModel.req))
            var that = this
            httpClient.invoke("LearnAPI.GetLearnData", req, function (res) {

                //console.log("获取学习数据",res)
                if (res.error) {
                    that.$message({ message: res.error })
                    return
                }
                that.listWord.push(...res.listItem)
                //console.log("合并结果",that.listWord)
                that.dataLoading = false
            })
        },
        ///加载当前单词
        loadCurrentWord: function () {
            this.currentWord = this.listWord[this.currentWordIndex]
            this.learnProgress = this.currentWordIndex / this.totalCount
            this.loadSpellItems([])

        },
        ///随机打乱数组
        shuffleArray: function (array) {
            for (let i = array.length - 1; i > 0; i--) {
                // 生成0到i之间随机整数
                const j = Math.floor(Math.random() * (i + 1));
                // 交换元素
                [array[i], array[j]] = [array[j], array[i]];
            }
            return array;
        },
        ///加载拼写项目
        loadSpellItems: function (arrs) {
            this.listSpellItems = [
                {
                    sentenceId: this.currentWord.sentenceId,
                    sentence: this.currentWord.sentence,
                    translate: this.currentWord.translate,
                    symbol: this.currentWord.symbol,
                    error: false,
                    items: this.generateSpellWords(this.currentWord.sentence)
                }
            ]
            this.spellItemIndex = -1
            this.moveNextSpellItem()
        },
        // 切换到上一句
        movePrevSpellItem: function () {
            if (this.spellItemIndex > 0) {
                this.spellItemIndex--;
                this.spellItem = this.listSpellItems[this.spellItemIndex];
                this.spellWordIndex = 0;
                this.showAnswer = 0;
                this.inputError = false;
                // 重置输入状态
                for (let wordObj of this.spellItem.items) {
                    for (let charObj of wordObj.chars) {
                        charObj.input = 0;
                        charObj.errChar = '';
                        charObj.show = 0;
                    }
                }
                this.playText(this.spellItem.sentence);

            }
        },
        ///加载下一个拼写项目
        moveNextSpellItem: function () {
            if (this.spellItemIndex + 1 >= this.listSpellItems.length) {
                this.addLearnData()
                //加载下一个单词
                this.moveToNext();
                return;
            }
            this.spellItemIndex++;
            this.spellItem = this.listSpellItems[this.spellItemIndex];
            this.spellWordIndex = 0;
            this.showAnswer = 0;
            this.inputError = false;
            // 重置输入状态
            for (let wordObj of this.spellItem.items) {
                for (let charObj of wordObj.chars) {
                    charObj.input = 0;
                    charObj.errChar = '';
                    charObj.show = 0;
                }
            }
            this.processAutoPlay();


        },
        ///处理自动播放
        processAutoPlay: async function () {
            if (this.config.autoPlay <= 0) {
                return
            }
            var num = this.config.autoPlay
            while (num > 0) {
                await this.playText(this.spellItem.sentence);
                //等待1秒
                await new Promise(resolve => setTimeout(resolve, 1000));
                num--;
            }
        },
        ///添加学习数据
        addLearnData: function () {
            var model = {
                sentenceId: this.spellItem.sentenceId,
                result: this.spellItem.error ? 0 : 1,
                spellTime: this.learnModel.learnType == "order" ? Math.floor(Date.now() / 1000) : 0
            }
            this.submitData.listLearnItem.push(model)
        },
        ///重新加载单词句子
        reloadCurrentSpellItem: function () {
            this.spellWordIndex = 0;
            this.showAnswer = 0;
            this.inputError = false;
            // 重置输入状态
            for (let wordObj of this.spellItem.items) {
                for (let charObj of wordObj.chars) {
                    charObj.input = 0;
                    charObj.errChar = '';
                    charObj.show = 0;
                }
            }
            this.playText(this.spellItem.sentence);
        },
        // 添加一个新方法来处理循环逻辑
        handleLoopLogic: function () {
            const loopMap = {
                'loop2': 2,
                'loop3': 3,
                'loop4': 4,
                'loop5': 5
            };

            // 初始化当前单词的循环次数（如果未初始化）
            if (this.loopCount === undefined) {
                this.loopCount = 1;
            } else {
                this.loopCount++;
            }

            // 根据不同的循环模式处理
            if (this.config.loopMode === 'order') {
                // 顺序模式，直接进入下一个
                this.moveNextSpellItem();
            }
            else if (this.config.loopMode === 'loop') {
                // 无限循环模式
                this.reloadCurrentSpellItem();
                return
            }
            else if (this.config.loopMode in loopMap) {
                // 特定次数循环模式
                if (this.loopCount >= loopMap[this.config.loopMode]) {
                    // 达到指定循环次数，移动到下一个
                    this.loopCount = 0;
                    this.moveNextSpellItem();
                } else {
                    // 未达到循环次数，重新加载当前单词
                    this.reloadCurrentSpellItem();
                }
            }
        },
        ///生成拼写字母
        generateSpellWords: function (text) {
            if (typeof text !== 'string') return [];

            // 使用空格分割，过滤空字符串
            const words = text.split(/\s+/).filter(Boolean);
            // 判断是否是英文字母
            const isLetter = (ch) => /^[A-Za-z]$/.test(ch);
            return words.map(word => {
                const chars = Array.from(word).map(ch => ({
                    char: ch,
                    type: isLetter(ch) ? 0 : 1,
                    input: 0,//0未输入，1=输入正确,2=输入错误
                    show: 0
                }));

                return {
                    word,
                    chars
                };
            });
        },
        ///播放提示音
        playAssetsSound: function (src) {
            //如果正在播放，则停止前一个播放
            if (!this.audio.paused) {
                this.audio.pause();
            }
            this.audio.src = src
            this.audio.play().catch(error => {
                console.log('播放失败:', error);
            });
        },
        ///播放键盘音效
        playKeyboardSound: function () {
            if (this.keyboardAudio == null || this.config.keyboardSound == "") {
                return
            }
            this.keyboardAudio.cloneNode();
            this.keyboardAudio.play().catch(e => console.log(e));

        },
        ///播放错误音效
        playErrorSound: function () {
            if (this.config.errorSound == "") {
                return
            }
            this.playAssetsSound(`./sound/${this.config.errorSound}`)
        },
        ///播放正确音效
        playCorrectSound: function () {
            if (this.config.correctSound == "") {
                return
            }
            this.playAssetsSound(`./sound/${this.config.correctSound}`)
        },
        ///播放单词发音
        playText: async function (text) {

            try {
                await textSoundPlayer.playText(text)
                if (this.audioNotAllowedError == true) {
                    this.audioNotAllowedError = false
                }
            }
            catch (error) {
                this.audioNotAllowedError = true
                //console.log('播放失败:', error);
            }

            //var playerName = this.config.soundName == "US" ? "@英语(美音)" : "@英语(英音)"
            // LightApp.sound.playText(text, playerName, this.config.playSpeed, function () {

            // })
        },
        ///改变当前输入单词的显示状态
        changeSpellWordShow: function () {
            //this.showAnswer = this.showAnswer==0?1:0
            var spellWord = this.getCurrentSpellWord()

            if (spellWord == null) {
                return
            }
            var rs = 0;
            var charText = ""
            for (var i = 0; i < spellWord.chars.length; i++) {
                var charObj = spellWord.chars[i]
                if (i == 0) {
                    rs = charObj.show == 0 ? 1 : 0
                }
                charObj.show = rs
                charText += charObj.char
            }
            if (rs == 1) {
                this.playText(charText)
            }
        },
        setWordMShow(wordObj, val) {
            if (!wordObj || !wordObj.chars) return;
            for (let charObj of wordObj.chars) {
                charObj.mshow = val;
            }

        },
        ///点击spell单词
        clickSpellWord: function (wordObj) {
            var text = "";
            for (let charObj of wordObj.chars) {
                text += charObj.char

            }
            this.playText(text)
        },
        ///改变当前句子显示状态
        changeAllSpellWordShow: function () {
            if (!this.spellItem || !this.spellItem.items) return null;
            this.showAnswer = this.showAnswer == 0 ? 1 : 0
            for (let wordObj of this.spellItem.items) {
                for (let charObj of wordObj.chars) {
                    charObj.show = this.showAnswer
                }
            }
        },
        ///更新循环次数
        updateLoopMode: function (mode) {
            this.config.loopMode = mode
            this.loopCount = 0
            switch (mode) {
                case "order":
                    this.config.loopName = "顺序切换"
                    break
                case "loop2":
                    this.config.loopName = "循环2次"
                    break
                case "loop3":
                    this.config.loopName = "循环3次"
                    break
                case "loop4":
                    this.config.loopName = "循环4次"
                    break
                case "loop5":
                    this.config.loopName = "循环5次"
                    break
                case "loop":
                    this.config.loopName = "无限循环"
                    break
            }
        },
        ///返回上一页
        goBack: function () {
            // if (this.submitData.listLearnItem.length == 0) {
            //     //如果没有数据直接返回
            //     this.$router.go(-1)
            //     return 
            // }
            ///无论如何都上传数据
            var that = this
            this.showLoading = true
            this.uploadLearnData(function () {
                that.$router.go(-1)
            })
        },
        ///打开设置对话框
        openConfigDialog: function () {
            var z = 1
            if (z == 1) {
                this.learnFinish()
                return
            }
            this.configDialog.show = true
            var that = this
            this.configDialog.callBack = function () {
                that.configDialog.show = false
                that.loadConfig()
            }
        },
        ///音标包裹
        symbolWrapper: function (symbol) {
            return stringHelper.symbolWrapper(symbol)
        },

        ///播放成功特效
        fireSuccessEffect: function () {
            var count = 200;
            var defaults = {
                origin: { y: 0.7 }
            };

            function fire(particleRatio, opts) {
                confetti({
                    ...defaults,
                    ...opts,
                    particleCount: Math.floor(count * particleRatio)
                });
            }

            fire(0.25, {
                spread: 26,
                startVelocity: 55,
            });
            fire(0.2, {
                spread: 60,
            });
            fire(0.35, {
                spread: 100,
                decay: 0.91,
                scalar: 0.8
            });
            fire(0.1, {
                spread: 120,
                startVelocity: 25,
                decay: 0.92,
                scalar: 1.2
            });
            fire(0.1, {
                spread: 120,
                startVelocity: 45,
            });
        },
        ///添加生词
        addNewWord: function () {
            var spellWord = this.getCurrentSpellWord()
            if (!spellWord) {
                return
            }
            var word = stringHelper.getWord(spellWord.word)

            var that = this
            var req = {
                bookId: this.learnModel.bookInfo.bookId,
                unitId: this.learnModel.unitInfo.unitId,
                word: word
            }
            httpClient.invoke("WordItemAPI.AddNewWord", req, function (res) {
                if (res.error) {
                    that.$message.error(res.error)
                    return
                }
                if (!res.success) {
                    that.$message.error(res.message)
                    return
                }
                that.$message.success(`已添加 ${word} 到生词本`)
            })
        }


    }
}



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cfg1 {
    display: flex;
    justify-content: center;
    margin-top: 30px;
}

.cfg2 {
    background: var(--ek-card-color2);
    width: 280px;
    height: 55px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--ek-text-color2);
    box-shadow: 5px 5px 5px #00000014;
}

.vpplay {
    background: #ff9900;
    color: white;
    padding-left: 20px;
    padding-right: 20px;
    margin-top: 20px;
    padding-top: 5px;
    padding-bottom: 5px;
    border-radius: 10px;
    font-size: 14px;
}

.vp1 {
    display: flex;
    justify-content: center;
}

.ctime {
    margin-left: 10px;
    color: var(--ek-text-color2);
    font-size: 16px;
}

.xg1 {
    margin-left: 5px;
    margin-right: 5px;
}

.lbleft {
    color: var(--ek-text-color2);
    font-weight: bold;
}



.lbwordpage {
    color: var(--ek-text-color2);
    font-size: 16px;
    font-weight: bold;
}

.lbcurword {
    margin-left: 20px;
    color: var(--ek-text-color2);
    max-width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 16px;
    font-weight: bold;
}

.v-top {
    display: flex;
    align-items: center;
    padding-left: 20px;
    padding-right: 20px;
    justify-content: space-between;
}

.wpv {
    background: #6183ff;
}

.wordProgress {
    height: 5px;
    background: var(--ek-card-color1);
    display: flex;
}

.vheader {
    height: 80px;
    box-shadow: 5px 5px 5px #0d0d0d17;
}

.lbspellpage {
    text-align: center;
    margin-top: 30px;
    color: var(--ek-text-color3);
}

.vkey {
    background: var(--ek-card-color2);
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 5px;
    padding-bottom: 5px;
    border-radius: 5px;
    margin-right: 10px;
    color: var(--ek-text-color2);
    font-family: '阿里巴巴普惠体 2.0 65 Medium';
    font-size: 13px;
    font-weight: bold;
}

.vkeytip {
    font-size: 14px;
    color: var(--ek-text-color2);
}

.vbottom {
    margin-bottom: 60px;
    display: flex;
    justify-content: center;
    gap: 30px;
}

.curspellword {
    border-color: #5252ff !important;
}

.char-err {
    color: #ff4848;
}

.char-right {
    color: var(--ek-text-color1);
}

.unshow {
    opacity: 1 !important;
}

.uninput {
    color: var(--ek-text-color3);
    opacity: 0;
}

.spitem {
    border-bottom: 5px solid var(--ek-card-color2);
    padding-bottom: 5px;
    display: flex;
    cursor: pointer;
}

.dsymbol {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    color: var(--ek-text-color2);
    font-size: 20px;
}

.lbspell {
    display: flex;
    justify-content: center;
    margin-top: 60px;
    font-size: 45px;
    font-weight: bold;
    flex-wrap: wrap;
    gap: 20px;
    margin-left: 50px;
    margin-right: 50px;
}

.lbtrans {
    text-align: center;
    font-size: 35px;
    margin-left: 20px;
    margin-right: 20px;
    color: var(--ek-text-color1);
}

.spell-container {
    height: 0px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.game-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    position: relative;
}

.game-header {
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
    background-color: #f5f5f5;
}

.game-area {
    flex: 1;
    position: relative;
    overflow: hidden;
    background-color: #f9f9f9;
}

.word-row {
    position: absolute;
    display: flex;
    flex-direction: row;
    left: 100%;
    height: 40px;
    /* 设置固定行高 */
    white-space: nowrap;
    transition: transform 0.1s linear;
    align-items: center;
    /* 垂直居中单词 */
}

.row-paused {
    background-color: rgba(230, 247, 255, 0.3);
}

.word-item {
    display: inline-block;
    padding: 5px 12px;
    margin: 0 10px;
    background-color: white;
    border: 1px solid #ddd;
    border-radius: 15px;
    cursor: pointer;
    user-select: none;
    transition: all 0.3s ease;
}

.word-item:hover {
    background-color: #e9f7fe;
    box-shadow: 0 0 10px rgba(0, 123, 255, 0.5);
    transform: scale(1.1);
    z-index: 10;
}

.word-clicked {
    opacity: 0;
    transform: scale(0.8);
    pointer-events: none;
}

.feedback-message {
    position: absolute;
    font-weight: bold;
    padding: 3px 8px;
    border-radius: 10px;
    animation: float-up 1s ease-out;
    pointer-events: none;
}

.correct-feedback {
    background-color: rgba(76, 175, 80, 0.7);
    color: white;
}

.wrong-feedback {
    background-color: rgba(244, 67, 54, 0.7);
    color: white;
}

@keyframes float-up {
    0% {
        opacity: 1;
        transform: translateY(0);
    }

    100% {
        opacity: 0;
        transform: translateY(-30px);
    }
}

.meaning-area {
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #e3f2fd;
    border-top: 1px solid #ddd;
}

.current-meaning {
    font-size: 18px;
    font-weight: bold;
}

.score {
    font-size: 18px;
    font-weight: bold;
}

.controls button {
    margin-left: 10px;
    padding: 5px 15px;
    background-color: #4caf50;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.controls button:hover {
    background-color: #45a049;
}

/* 保留原有样式 */
.secitem {
    margin-left: 20px;
}

.shortcut {
    display: flex;
    padding-left: 20px;
    padding-top: 15px;
    padding-right: 20px;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e3e3e3;
    padding-bottom: 10px;
}

.navcontainer {
    padding-top: 10px;
    padding-bottom: 20px;
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
    align-items: baseline;
}

.selnav {
    font-size: 20px !important;
    font-weight: bold;
    color: #000000 !important;
}

.nav-item {
    margin-right: 20px;
    color: #666666;
    font-size: 14px;
}

/* 添加已点击状态的样式 */
.moving-word[clicked="true"] {
    /* 删除此处的样式 */
}

@keyframes shake {
    0% {
        transform: translateX(0);
    }

    20% {
        transform: translateX(-10px);
    }

    40% {
        transform: translateX(10px);
    }

    60% {
        transform: translateX(-10px);
    }

    80% {
        transform: translateX(10px);
    }

    100% {
        transform: translateX(0);
    }
}

.spitem.shake {
    animation: shake 0.4s;
}
</style>